module.exports = __webpack_public_path__ + "img/Chevron-Down_24px_2_Icon.3ce83fa3.svg";